<div class="word-guess-board" id="puzzle-screenshot">
  <div class="word-guess-board-grid-wrapper" #gridWrapper>
    <div
      class="word-guess-board-grid-scaler"
      [style.height.px]="gridHeightPX * scaleValue"
      [style.width.px]="gridWidthPX * scaleValue"
    >
      <div
        class="word-guess-board-grid"
        [style.transform]="'scale(' + scaleValue + ')'"
        [style.height.px]="gridHeightPX"
        [style.width.px]="gridWidthPX"
      >
        <div
          class="word-guess-board-row"
          *ngFor="let row of rows; let rowIndex = index"
          [class.is-invalid]="rowIndex === invalidRowIndex"
          [class.is-revealing]="rowIndex === revealRowIndex"
        >
          <div
            class="word-guess-board-tile"
            *ngFor="let tile of row; let tileIndex = index"
            [ngClass]="'is-' + tile.state"
            [class.is-filled]="tile.letter.length > 0"
            [class.is-editable]="rowIndex === activeRowIndex"
            [class.has-cursor]="rowIndex === activeRowIndex && tileIndex === cursorIndex"
            [style.animation-delay.ms]="rowIndex === revealRowIndex ? tileIndex * 200 : 0"
            (click)="onTileClicked(rowIndex, tileIndex)"
          >
            <span class="word-guess-board-tile-letter">{{ tile.letter }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <lib-app-word-guess-keyboard
    *ngIf="showKeyboard"
    class="word-guess-board-keyboard"
    [letterStates]="keyStates"
    [disabled]="gameOver"
    [canSubmit]="canSubmit"
    [canDelete]="canDelete"
    (letterPressed)="onLetter($event)"
    (enterPressed)="onSubmit()"
    (deletePressed)="onDelete()"
  />
</div>
